module.exports = __webpack_public_path__ + "static/media/PORTFOLIO2.3994f632.jpg";